import ReactSelect from 'react-select'
import type { SelectProps } from './index'
import React from 'react'
import { Icon, ShowIf, TooltipPopOver } from '@ztechapps/webui.util'
import { useReactSelect } from './useReactSelect'
import { Col } from 'react-bootstrap'

export const Select = (props: SelectProps) => {
  const properties = useReactSelect(props)

  return <ReactSelect {...properties} />
}

export const MultiSelect = (props: SelectProps) => {
  const properties = useReactSelect(props)

  return <ReactSelect {...properties} isMulti={true} />
}
export const SelectOptionColumn = ({ children, className = '' }: { className?: string; children: React.ReactNode }) => {
  return <Col className={`border-bottom px-1 py-2  text-truncate ${className}`}>{children}</Col>
}

export type SelectOptionCellProps = { value?: string; className?: string; icon?: string }

export const SelectOptionCell = ({ value, className = '', icon }: SelectOptionCellProps) => {
  // Cell text stays inline inside a `text-truncate` box, so an overlong value ends in an ellipsis and a
  // `TooltipPopOver` carries the full text. Don't wrap it in `IconValueBlock`: its flex row never shrinks its text item, so the
  // cell would clip the value at the edge with no ellipsis.
  return (
    <SelectOptionColumn className={className}>
      <ShowIf condition={!!icon}>
        <Icon name={icon} />{' '}
      </ShowIf>
      <TooltipPopOver tooltipBody={value}>
        <span>{value}</span>
      </TooltipPopOver>
    </SelectOptionColumn>
  )
}
